<template>
  <div id="psw" class="div_card">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="160px">
      <p style="font-size:1em; padding:0.5em;">
        若您忘記設定的密碼，請輸入<font color="red">身分證字號</font>、<font color="red">姓名</font>、<font color="red">聯絡電話</font>，按【確定】按鈕後，系統會將密碼寄至您設定的E-MAIL信箱。
      </p>
      <el-form-item label="身分證字號" prop="idNo">
        <el-input v-model="ruleForm.idNo" style="width:9.375em;" :maxlength="10">
          <i class="el-icon-edit el-input__icon"
             slot="suffix"/></el-input>
      </el-form-item> 
      <el-form-item label="姓名" prop="name">
        <el-input v-model="ruleForm.name" style="width:9.375em;" :maxlength="20">
          <i class="el-icon-edit el-input__icon"
             slot="suffix"/></el-input>
      </el-form-item> 
      <el-form-item label="聯絡電話" prop="phoneNo1">
        <el-input v-model="ruleForm.phoneNo1" style="width:9.375em;" :maxlength="20">
          <i class="el-icon-edit el-input__icon"
             slot="suffix"/></el-input>
      </el-form-item> 
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">{{$t('message.Send_cmd')}}<i class="el-icon-success el-icon--right"/></el-button>
      </el-form-item>
    </el-form>
  </div> 
</template>

<script>
export default {
  name: 'psw',
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
  },
  data () {
    var checkIdNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('身分證字號不能空白'));
      } else {
        callback();
      }
    };
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('姓名不能空白'));
      } else {
        callback();
      }
    };
    var checkPhoneNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('聯絡電話不能空白'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        eId: 0,
        sysId: 0,
        idNo: '',
        name: '',
        phoneNo1: ''
      },
      rules:{
       idNo:[{validator: checkIdNo,trigger:"blur"}],
       name:[{validator: checkName,trigger:"blur"}],
       phoneNo1:[{validator: checkPhoneNo,trigger:"blur"}],
      }
    }
  },
  methods: {
    onSubmit() {
      var vm = this
      this.$http.put('./WebApi/Tools/SendPSW',this.ruleForm)
                .then((response) =>{ 
                    if (!(!response.data || (response.data == "null"))) {
                      switch (response.data) {
                        case 1:
                            vm.$notify({
                                        title: vm.$t('message.Warning_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,請檢查<i style="background:yellow;">輸入資料</i>是否正確</strong>',
                                        type: 'warning',
                                        offset: 150
                                      });
                            break;
                        case 2:
                            vm.$notify({
                                        title: vm.$t('message.Warning_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,您的<i style="background:yellow;">E-Mail帳號</i>尚未設定</strong>',
                                        type: 'warning',
                                        offset: 150
                                      });
                            break;
                        case 3:
                            vm.$notify({
                                        title: vm.$t('message.Warning_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,您的<i style="background:yellow;">密碼</i>尚未設定</strong>',
                                        type: 'warning',
                                        offset: 150
                                    });
                            break;
                        case 4:
                            vm.$notify({
                                        title: vm.$t('message.Success_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>恭喜您,寄件成功</strong>',
                                        type: 'success',
                                        offset: 150
                                      });
                            break;
                        default:
                            vm.$notify.error({
                                              title: vm.$t('message.Error_txt'),
                                              dangerouslyUseHTMLString: true,
                                              message: '<strong>對不起,寄件失敗</strong>',
                                              offset: 150
                                            });
                            break;
                      }
                    } else {
                      vm.$notify.error({
                                        title: vm.$t('message.Error_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,寄件失敗</strong>',
                                        offset: 150
                                      });
                    }
                })
                .catch(function (error) {
                  vm.$notify.error({
                                    title: vm.$t('message.Error_txt'),
                                    dangerouslyUseHTMLString: true,
                                    message: '<strong>對不起,網路連線失敗</strong>',
                                    offset: 150
                                  });
                })
    },
    submitForm(ruleForm) {
      var vm = this
      this.$refs.ruleForm.validate((valid) => {        
        console.log('======submitForm ===== valid:'+valid)
        if (valid) {
          this.$http.put('./WebApi/Tools/SendPSW',vm.ruleForm)
                    .then((response) =>{
                        if (!(!response.data || (response.data == "null"))) {
                            switch (response.data) {
                                case 1:
                                    vm.$notify({
                                                title: vm.$t('message.Warning_txt'),
                                                dangerouslyUseHTMLString: true,
                                                message: '<strong>對不起,請檢查<i style="background:yellow;">輸入資料</i>是否正確</strong>',
                                                type: 'warning',
                                                offset: 150
                                              });
                                    break;
                                case 2:
                                    vm.$notify({
                                                title: vm.$t('message.Warning_txt'),
                                                dangerouslyUseHTMLString: true,
                                                message: '<strong>對不起,您的<i style="background:yellow;">E-Mail帳號</i>尚未設定</strong>',
                                                type: 'warning',
                                                offset: 150
                                              });
                                    break;
                                case 3:
                                    vm.$notify({
                                                title: vm.$t('message.Warning_txt'),
                                                dangerouslyUseHTMLString: true,
                                                message: '<strong>對不起,您的<i style="background:yellow;">密碼</i>尚未設定</strong>',
                                                type: 'warning',
                                                offset: 150
                                              });
                                    break;
                                case 4:
                                    vm.$notify({
                                                title: vm.$t('message.Success_txt'),
                                                dangerouslyUseHTMLString: true,
                                                message: '<strong>恭喜您,寄件成功</strong>',
                                                type: 'success',
                                                offset: 150
                                              });
                                    break;
                                default:
                                    vm.$notify.error({
                                                      title: vm.$t('message.Error_txt'),
                                                      dangerouslyUseHTMLString: true,
                                                      message: '<strong>對不起,寄件失敗</strong>',
                                                      offset: 150
                                                    });
                                    break;
                            }
                        } else {
                          vm.$notify.error({
                                            title: vm.$t('message.Error_txt'),
                                            dangerouslyUseHTMLString: true,
                                            message: '<strong>對不起,寄件失敗</strong>',
                                            offset: 150
                                          });
                        }
                    })
                    .catch(function (error) {
                      vm.$notify.error({
                                        title: vm.$t('message.Error_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,網路連線失敗</strong>',
                                        offset: 150
                                      });
                    })
        } else {
          this.$notify.error({
                              title: this.$t('message.Error_txt'),
                              dangerouslyUseHTMLString: true,
                              message: '<strong>對不起,驗證失敗</strong>',
                              offset: 150
                            });
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$nextTick(function() {
        this.$refs[formName].resetFields();
      })
    }
  },
  created () {
    console.log('======created PSWView=====')
    this.ruleForm.eId = this.setting.enrollID[0].codeName;
    this.ruleForm.sysId = this.sysId;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PSWView.vue